import axiosInstance from "../../utils/AxiosInterceptor";

const cityService = {
  // Retrieve all cities
  getCityByName: async (cityName, signal) => {
    try {
      const response = await axiosInstance.get(`/city/name/${encodeURIComponent(cityName)}`, { params: { view: 'map' }, signal });
      return response.data;
    } catch (error) {
      console.error('Error retrieving cities:', error);
      throw error;
    }
  },
}
  export default cityService
